{"name": "evse-web", "buildversion": "1.0.13_SNAPSHOT_11042026-084841", "buildTime": "04/11/2026 08:48:50"}